import React, { createContext, useContext, useMemo } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://ksiega.kalmarry.pl/new";

const ApiContext = createContext();

export function ApiProvider({ children }) {
  // Memoize so the instance (and its interceptors) is created only once per mount
  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_URL,
      headers: { "Content-Type": "application/json" },
      timeout: 15000,
    });

    // Attach auth token to every request
    instance.interceptors.request.use((config) => {
      const token = localStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    // On 401 / expired token: clear local auth state and redirect to login
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          // Avoid redirect loop on the login page itself
          if (!window.location.pathname.startsWith("/login")) {
            window.location.href = "/login";
          }
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi() {
  return useContext(ApiContext);
}
